const es_upf = {
  LOAN_ANALYSING:
    "Tu solictiud ha sido procesada. Te contactaremos una vez se haya analizado. ¡Estáte atent@!",
};

export default es_upf;
